"use client";

import { LCWork, LCWorkParams } from "@libry-content/integrations";
import { DefaultContainer } from "../../../../../../../components/ContentContainer";
import { Box, Heading } from "@biblioteksentralen/react";
import ItemGrid from "../../../../../../../searchAndCollection/components/works/ItemGrid";
import { useTranslation } from "../../../../../../../utils/hooks/useTranslation";
import SommerlesPopularReadingLinks from "../../../../../../../components/sommerles/SommerlesPopularReadingLinks";
import { getGradeLabel, Grade } from "../../../../../../../components/sommerles/sommerlesPopularReading";

export const ClientSidePopularWorks = ({ worksParams, grade }: { worksParams: LCWorkParams[]; grade: Grade }) => {
  const { t } = useTranslation();
  const works = worksParams.map((workParams) => new LCWork(workParams));
  return (
    <DefaultContainer margin="1rem auto 3rem" padding="0">
      <Box padding="1rem 2rem">
        <Heading as="h1" size="lg" marginBottom=".5rem">
          {t("Dette leser {trinn}", { trinn: getGradeLabel(grade, t) })}
        </Heading>
        <ItemGrid items={works} headingSize="h2" />
        <SommerlesPopularReadingLinks marginTop="3rem" />
      </Box>
    </DefaultContainer>
  );
};
